import { useEffect, useState } from 'react';

export const useAutoAdvance = (length, ms) => {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setIndex((prev) => (prev + 1) % length), ms);
    return () => clearInterval(id);
  }, [length, ms]);
  return index;
};
